import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const messages = ['🔥 Más de 500 personas ya aplicaron el Reset este fin de semana', '⏰ Este precio cierra el domingo a las 23:59', '🔥 El protocolo se aplica en un solo fin de semana', '⏰ Después del domingo, el precio sube a $19.990'];
export function UrgencyPopups() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay of 5 seconds before showing the first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // When hidden, wait 8-12 seconds before showing the next message
      const waitTime = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      const timer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % messages.length);
        setIsVisible(true);
      }, waitTime);
      return () => clearTimeout(timer);
    } else {
      // When visible, hide after 4 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  return <div className="fixed bottom-4 left-4 right-4 sm:right-auto sm:left-6 sm:bottom-6 z-50 pointer-events-none" data-id="element-173">
      <AnimatePresence data-id="element-174">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        duration: 0.4,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="bg-charcoal-700 border border-amber/30 rounded-sm p-4 shadow-2xl flex items-start gap-3 w-full sm:w-[320px] pointer-events-auto relative overflow-hidden" data-id="element-175">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber/50" data-id="element-176" />
            <p className="text-offwhite/90 text-sm font-medium leading-snug pr-6" data-id="element-177">
              {messages[currentIndex]}
            </p>
            <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-offwhite/40 hover:text-offwhite transition-colors" aria-label="Cerrar notificación" data-id="element-178">
              <XIcon className="w-4 h-4" data-id="element-179" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}